import { ICONS } from '../../constants';
const storageRoot = 'storage';
const medsStorageRootName = 'medsStorage';
const hygProdsStorageRootName = 'hygProdsStorage';
const addMedStorageRootName = 'addMedStorage';
const addHygProdStorageRootName = 'addHygProdStorage';
const needsRoot = 'needs';
const medsNeedsRootName = 'medsNeeds';
const hygProdsNeedsRootName = 'hygProdsNeeds';

export default {
    path: '/',
    name: 'main',
    scan2dDataMatrix: {
        path: 'scan-2d-data-matrix',
        name: 'scan2dDataMatrix',
        meta: {
            pageTitle: 'scan.dataMatrix.intro',
            menu: {
                icon: ICONS.scan2dDataMatrix,
                label: 'scan.dataMatrix.intro',
            },
        },
    },
    storage: {
        path: storageRoot,
        name: 'storage',
        meta: {
            pageTitle: 'storage.pageTitle',
            menu: {
                icon: ICONS.hospitalBox,
                label: 'storage.pageTitle',
            },
        },
        meds: {
            path: `${storageRoot}/meds`,
            name: medsStorageRootName,
            meta: {
                pageTitle: 'storage.meds.pageTitle',
                menu: {
                    label: 'storage.meds.pageTitle',
                },
            },
        },
        hygProds: {
            path: `${storageRoot}/hyg-prods`,
            name: hygProdsStorageRootName,
            meta: {
                pageTitle: 'storage.hygProds.pageTitle',
                menu: {
                    label: 'storage.hygProds.pageTitle',
                },
            },
        },
        addMeds: {
            path: `${storageRoot}/add-meds`,
            name: addMedStorageRootName,
            meta: {
                pageTitle: 'storage.add.addMeds.pageTitle',
                breadcrumbTitle: 'storage.add.addMeds.pageTitle',
                breadcrumbMobileTitle: 'storage.add.addMeds.breadcrumbMobileTitle',
                breadcrumbIcon: ICONS.plusCircle,
                breadcrumbs: [
                    {
                        translationLabel: 'storage.meds.breadcrumbTitle',
                        mobileTranslationLabel: 'storage.meds.breadcrumbMobileTitle',
                        name: medsStorageRootName,
                        icon: ICONS.hospitalBox,
                    },
                ],
            },
        },
        scanMedBarcodeAndAdd: {
            path: `${storageRoot}/scan-med-barcode-and-add`,
            name: 'scanMedBarcodeAndAdd',
            meta: {
                pageTitle: 'scan.twelveDigitCode.title',
                breadcrumbTitle: 'scan.twelveDigitCode.title',
                breadcrumbMobileTitle: 'scan.start',
                breadcrumbIcon: ICONS.magnifyScan,
                breadcrumbs: [
                    {
                        translationLabel: 'storage.meds.breadcrumbTitle',
                        mobileTranslationLabel: 'storage.meds.breadcrumbMobileTitle',
                        name: medsStorageRootName,
                        icon: ICONS.hospitalBox,
                    },
                    {
                        translationLabel: 'storage.add.addMeds.pageTitle',
                        mobileTranslationLabel: 'storage.add.addMeds.breadcrumbMobileTitle',
                        name: addMedStorageRootName,
                        icon: ICONS.plusCircle,
                    },
                ],
            },
        },
        scan2DDataMatrixAndAdd: {
            path: `${storageRoot}/scan-2d-data-matrix-and-add`,
            name: 'scan2DDataMatrixAndAdd',
            meta: {
                pageTitle: 'scan.dataMatrix.intro',
                breadcrumbTitle: 'scan.dataMatrix.intro',
                breadcrumbMobileTitle: 'scan.start',
                breadcrumbIcon: ICONS.scan2dDataMatrix,
                breadcrumbs: [
                    {
                        translationLabel: 'storage.meds.breadcrumbTitle',
                        mobileTranslationLabel: 'storage.meds.breadcrumbMobileTitle',
                        name: medsStorageRootName,
                        icon: ICONS.hospitalBox,
                    },
                    {
                        translationLabel: 'storage.add.addMeds.pageTitle',
                        mobileTranslationLabel: 'storage.add.addMeds.breadcrumbMobileTitle',
                        name: addMedStorageRootName,
                        icon: ICONS.plusCircle,
                    },
                ],
                addToStorage: true,
            },
        },
        addHygProds: {
            path: `${storageRoot}/add-hyg-prods`,
            name: addHygProdStorageRootName,
            meta: {
                pageTitle: 'storage.add.addHygProds.pageTitle',
                breadcrumbTitle: 'storage.add.addHygProds.pageTitle',
                breadcrumbMobileTitle: 'storage.add.addHygProds.breadcrumbMobileTitle',
                breadcrumbIcon: ICONS.plusCircle,
                breadcrumbs: [
                    {
                        translationLabel: 'storage.hygProds.breadcrumbTitle',
                        mobileTranslationLabel: 'storage.hygProds.breadcrumbMobileTitle',
                        name: hygProdsStorageRootName,
                        icon: ICONS.hospitalBox,
                    },
                ],
            },
        },
    },
    needs: {
        path: needsRoot,
        name: 'needs',
        meta: {
            pageTitle: 'needs.pageTitle',
            menu: {
                icon: ICONS.bookMultiple,
                label: 'needs.pageTitle',
            },
        },
        meds: {
            path: `${needsRoot}/meds`,
            name: medsNeedsRootName,
            meta: {
                pageTitle: 'needs.meds.pageTitle',
                menu: {
                    label: 'needs.meds.pageTitle',
                },
            },
        },
        hygProds: {
            path: `${needsRoot}/hyg-prods`,
            name: hygProdsNeedsRootName,
            meta: {
                pageTitle: 'needs.hygProds.pageTitle',
                menu: {
                    label: 'needs.hygProds.pageTitle',
                },
            },
        },
        addMed: {
            path: `${needsRoot}/add-meds`,
            name: 'addMedNeeds',
            meta: {
                pageTitle: 'needs.addMeds.pageTitle',
                breadcrumbTitle: 'needs.addMeds.pageTitle',
                breadcrumbMobileTitle: 'storage.add.addMeds.breadcrumbMobileTitle',
                breadcrumbIcon: ICONS.plusCircle,
                breadcrumbs: [
                    {
                        translationLabel: 'needs.meds.breadcrumbTitle',
                        mobileTranslationLabel: 'needs.meds.breadcrumbMobileTitle',
                        name: medsNeedsRootName,
                        icon: ICONS.bookMultiple,
                    },
                ],
            },
        },
        addHygProd: {
            path: `${needsRoot}/add-hyg-prods`,
            name: 'addHygProdNeeds',
            meta: {
                pageTitle: 'needs.addHygProds.pageTitle',
                breadcrumbTitle: 'needs.addHygProds.pageTitle',
                breadcrumbMobileTitle: 'storage.add.addHygProds.breadcrumbMobileTitle',
                breadcrumbIcon: ICONS.plusCircle,
                breadcrumbs: [
                    {
                        translationLabel: 'needs.hygProds.breadcrumbTitle',
                        mobileTranslationLabel: 'needs.hygProds.breadcrumbMobileTitle',
                        name: hygProdsNeedsRootName,
                        icon: ICONS.bookMultiple,
                    },
                ],
            },
        },
    },
    orders: {
        path: 'orders',
        name: 'orders',
        meta: {
            pageTitle: 'order.pageTitle',
            menu: {
                icon: ICONS.shopping,
                label: 'order.pageTitle',
            },
        },
        orderProds: {
            path: 'order-prods',
            name: 'orderProds',
            meta: {
                pageTitle: 'order.prods.pageTitle',
                menu: {
                    label: 'order.prods.menuTitle',
                },
            },
        },
        basket: {
            path: 'basket-orders',
            name: 'basketOrders',
            meta: {
                pageTitle: 'order.basket.pageTitle',
                menu: {
                    label: 'order.basket.pageTitle',
                },
            },
        },
        incoming: {
            path: 'incoming-orders',
            name: 'incomingOrders',
            meta: {
                pageTitle: 'incoming.pageTitle',
                menu: {
                    icon: ICONS.truckPlus,
                    label: 'incoming.pageTitle',
                },
            },
            pending: {
                path: 'incoming-pending-orders',
                name: 'incomingPendingOrders',
                meta: {
                    pageTitle: 'incoming.pendingOrders.pageTitle',
                    menu: {
                        label: 'incoming.pendingOrders.pageTitle',
                    },
                },
            },
            history: {
                path: 'incoming-history-orders',
                name: 'incomingHistoryOrders',
                meta: {
                    pageTitle: 'incoming.historyOrders.pageTitle',
                    menu: {
                        label: 'incoming.historyOrders.pageTitle',
                    },
                },
            },
        },
        outgoing: {
            path: 'outgoing-orders',
            name: 'outgoingOrders',
            meta: {
                pageTitle: 'outgoing.pageTitle',
                menu: {
                    icon: ICONS.handHeart,
                    label: 'outgoing.pageTitle',
                },
            },
            pending: {
                path: 'outgoing-pending-orders',
                name: 'outgoingPendingOrders',
                meta: {
                    pageTitle: 'outgoing.pendingOrders.pageTitle',
                    menu: {
                        label: 'outgoing.pendingOrders.pageTitle',
                    },
                },
            },
            closeOrgPending: {
                path: 'close-org-outgoing-pending-orders',
                name: 'closeOrgOutgoingPendingOrders',
                meta: {
                    pageTitle: 'outgoing.closeOrgPendingOrders.pageTitle',
                    menu: {
                        label: 'outgoing.closeOrgPendingOrders.pageTitle',
                    },
                },
            },
            history: {
                path: 'outgoing-history-orders',
                name: 'outgoingHistoryOrders',
                meta: {
                    pageTitle: 'outgoing.historyOrders.pageTitle',
                    menu: {
                        label: 'outgoing.historyOrders.pageTitle',
                    },
                },
            },
        },
    },
    settings: {
        path: 'settings',
        name: 'settings',
        meta: {
            pageTitle: 'settings.title',
            menu: {
                icon: ICONS.settings,
                label: 'settings.title',
            },
        },
    },
    faq: {
        path: 'faq',
        name: 'faq',
        meta: {
            pageTitle: 'faq.title',
            menu: {
                icon: ICONS.help,
                label: 'faq.title',
            },
        },
    },
    profile: {
        path: 'profile',
        name: 'profile',
        meta: {
            pageTitle: 'profile.pageTitle',
            menu: {
                icon: ICONS.account,
                label: 'profile.pageTitle',
            },
        },
    },
};
